import { EditAction } from '../shared/enum/EditAction';

export interface SocialMediaRateModel {
    id: number,
    clientId: number,
    rateValue: number,
    startOfPeriod: Date | null,
    endOfPeriod: Date | null,
    editAction: EditAction,
    userId: number
}

export const socialMediaRateModelInitial: SocialMediaRateModel = {
    id: 0,
    clientId: 0,
    rateValue: 0,
    startOfPeriod: null,
    endOfPeriod: null,
    editAction: EditAction.NONE,
    userId: 0
};

export type ClientIdmConversionRateModel = SocialMediaRateModel;
export type ClientIrsConversionRateModel = SocialMediaRateModel;
